export default __webpack_public_path__ + "static/media/356.43b3a71b.jpg";